import { FormsMultilineInput, Spinner } from '@platform/components';
import { Control, FormState } from 'react-hook-form';
import { UpdateDiscoveryCallFormData } from '.';

type OtherUpdateContentProps = {
  isSaving: boolean;
  control: Control<UpdateDiscoveryCallFormData>;
  formState: FormState<UpdateDiscoveryCallFormData>;
};

export const OtherUpdateContent = (props: OtherUpdateContentProps) => {
  return (
    <div className='flex flex-col gap-4 md:mt-8 md:w-[500px]'>
      {props.isSaving ?
        <div className='flex justify-center'>
          <Spinner />
        </div>
      : <div className='w-full items-stretch'>
          <div className='text-sm'>Describe your update</div>
          <FormsMultilineInput
            control={props.control}
            name='otherUpdateDetails'
            placeholder="Let us know what's going on"
            characterCount={500}
            rules={{ required: `Let us know what's going on to continue` }}
            formsError={props.formState.errors['otherUpdateDetails']}
          />
        </div>
      }
    </div>
  );
};
